import { NgModule } from '@angular/core';

import { routing, appRoutingProviders } from './high-risk-registry.routing';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../../pipes/pipes.module';
import { DataTableModule } from '../../data-table/data-table.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { SharedModule } from '../../shared/shared.module';
import { HighRiskRegistryComponent } from './high-risk-registry.component';
import { RankingsModule } from '../rankings/rankings.module';
import { DataWidgetsModule } from '../rankings/data-widgets/data-widgets.module';

@NgModule({
  declarations: [HighRiskRegistryComponent],
  imports: [
    TooltipModule,
    DataTableModule,
    PipesModule,
    CommonModule,
    SharedModule,
    routing,
    RankingsModule,
    DataWidgetsModule
  ],
  exports: [],
  providers: [appRoutingProviders]
})
export class HighRiskRegistryModule {}
